import { render } from "./IotComputersComponent.vue?vue&type=template&id=f3151186"
import script from "./IotComputersComponent.vue?vue&type=script&lang=js"
export * from "./IotComputersComponent.vue?vue&type=script&lang=js"

import "./IotComputersComponent.vue?vue&type=style&index=0&id=f3151186&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__